import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/tclip/agents")({
  component: lazyRouteComponent(async () => await import("../../../../views/tclip/Dashboard")),
});
